import React, { useContext } from 'react';
import Context from "../context/context";
import { DateTime } from 'luxon';

function format_date_full_luxon(date, type, endDate = null) {
  switch (type) {
    case "day":
      return date.toFormat("cccc, dd LLLL yyyy");

    case "week":
      return `Week of ${date.toFormat("dd LLL yyyy")} - ${endDate.toFormat("dd LLL yyyy")}`;

    case "month":
      return date.toFormat("LLLL yyyy");

    case "year":
      return date.toFormat("yyyy");

    default:
      return date.toISODate();
  }
}
const SelectedDate = props => {
  const { activeFilters, language } = useContext(Context);
  const { text } = props;

  let selected_date = "";

  if (typeof activeFilters["top_filter"] !== "undefined" && activeFilters["top_filter"].type === "date") {
    const top_filter = activeFilters["top_filter"];

    if (top_filter.value === "all") {
      selected_date = "Viewing all " + language.type;
    } else {
      const tz = "Europe/London";

      if (top_filter.name === "daily") {
        selected_date = "Viewing " + language.type + " on ";

        const date = top_filter.options.find((f) => f.value === top_filter.value);

        if (typeof date !== "undefined") {
          if (date.name === "Today" || date.name === "Tomorrow") {
            selected_date += date.name;
          } else {
            const dt = DateTime.fromSeconds(date.value, { zone: tz });
            selected_date += format_date_full_luxon(dt, "day");
          }
        }

      } else if (top_filter.name === "weekly") {
        const start = DateTime.fromSeconds(top_filter.value, { zone: tz });
        const end = start.plus({ days: 6 });
        selected_date = format_date_full_luxon(start, "week", end);

      } else if (top_filter.name === "monthly") {
        const dt = DateTime.fromSeconds(top_filter.value, { zone: tz });
        selected_date = format_date_full_luxon(dt, "month");

      } else if (top_filter.name === "yearly") {
        const dt = DateTime.fromSeconds(top_filter.value, { zone: tz });
        selected_date = format_date_full_luxon(dt, "year");
      }
    }
  }



  return (
    <>
      {text + selected_date}

    </>
  )
}

export default SelectedDate;
